import axios from '@/http.js'
import * as types from './mutation-types'
import e6BaseUrl from '@/e6GetBaseUrl.js'
let PAGESIZE_FENCE = 500
let PAGESIZE_SMART = 500
let curPage_fence = 1
let curPage_smart = 1
// let fenceDatas_temp = [];

const actions = {
  // 更新电子围栏数据
  updateDenceDatas ({ commit }, params) {
    curPage_fence = 1
    return new Promise((resolve, reject) => {
      requestFences({ commit, params, resolve, reject, dataArr: [] })
    })
  },
  // 更新轨迹数据
  updateLineDatas ({ commit }, params) {
    curPage_fence = 1
    return new Promise((resolve, reject) => {
      requestLines({ commit, params, resolve, reject, dataArr: [] })
    })
  },
  // 更新标准轨迹数据
  updateStandardTrackData ({ commit }, params) {
    return axios.post(`${e6BaseUrl}/trajectory/point/get_line_gps_list`, {
      areaId: params.areaId
    })
      .then(res => {
        if (res.code == 0 && Array.isArray(res.data)) {
          commit(types.UPDATE_STANDARD_TRACK_DATA, res.data)
        }
      })
  },
  requestCategoryList ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`${e6BaseUrl}fence/area/get_category`).then(res => {
        if (res.code == 0) {
          if (res.data && Array.isArray(res.data)) {
            commit(types.CATEGORY_LIST, { data: res.data })
            resolve(res.data)
          }
        }
        resolve()
      })
    })
  },
  // 智能推荐请求
  requestSmartDatas ({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      requestSmart({ commit, state, params, resolve, reject})
    })
  }
}
const requestFences = function (opts) {
  axios
    .post(`${e6BaseUrl}fence/area/find_area_list`, {
      pageSize: PAGESIZE_FENCE,
      curPage: curPage_fence,
      typeId: opts.params.typeId
    })
    .then(res => {
      if (res.code == 0) {
        if (res.data && Array.isArray(res.data.content)) {
          opts.dataArr = [...opts.dataArr, ...res.data.content]
        }
        if (res.data.last) {
          // 数据请求完毕
          opts.commit(types.UPDATE_FENCE_DATAS, {
            data: opts.dataArr,
            typeId: opts.params.typeId
          })
          opts.resolve(opts.dataArr)
        } else {
          curPage_fence++
          requestFences(opts)
        }
      }
    })
}
const requestLines = function (opts) {
  axios
    .post(`${e6BaseUrl}fence/line/get_line_list`, {
      pageSize: PAGESIZE_FENCE,
      curPage: curPage_fence
    })
    .then(res => {
      if (res.code == 0) {
        if (res.data && Array.isArray(res.data.content)) {
          opts.dataArr = [...opts.dataArr, ...res.data.content]
        }
        if (res.data.last) {
          // 数据请求完毕
          opts.commit(types.UPDATE_LINE_DATAS, {
            data: opts.dataArr
          })
          opts.resolve(opts.dataArr)
        } else {
          curPage_fence++
          requestLines(opts)
        }
      }
    })
}
// 请求获取推荐数据
const requestSmart = function (opts) {
  let smartDatas = opts.state.smartDatas
  let result = []
  axios
    .post(`${e6BaseUrl}/fence/area/find_intelligenteCommendation_list`, {
      pageSize: PAGESIZE_SMART,
      ...opts.params
    })
    .then(res => {
      if (res.code == 0) {
        // 请求成功
        if (res.data && Array.isArray(res.data.content)) {
          result = [...smartDatas, ...res.data.content]
        }
        // 修改 vuex 中的 smartDatas
        opts.commit(types.UPDATE_SMART_DATAS, {
          data: result
        })
        // 返回是否是最后一页
        opts.resolve({
          last: res.data.last,
          total: res.data.totalElements
        })
      }
    })
    .catch(err => {
      console.log(err)
    })
}
export default actions



// WEBPACK FOOTER //
// ./src/store/actions.js